import { FC } from "react";
import { useDetailTeamPage } from "../../hooks/useDetailTeamPage";
import LoadingPage from "../../shared/LoadingPage/LoadingPage";
import TeamDetail from "../../leopart-update/pages/TeamDetail";

export const DetailTeamPage: FC = () => {
  const { query, onClickStartIcon, isLoading, goBack } = useDetailTeamPage();

  if (!query.data) {
    return <LoadingPage />;
  }

  return (
    <TeamDetail
      team={query.data}
      teamQuery={query}
      onClickStar={onClickStartIcon}
      isStarLoading={isLoading}
      goBack={goBack}
    />
  );
};
